// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"9936038f","50":"2013f8b3","143":"560051a6","201":"cd0166d0","367":"253e322d","464":"979da61e","799":"cf37e217"}[chunkId] + ".css";
};